import { FaFileExcel } from "react-icons/fa";

const ExcelIcon = ({ size = 40, color = "green" }) => {
  return <FaFileExcel size={size} color={color} />;
};

export default ExcelIcon;
